import { render, staticRenderFns } from "./ThaiAddressInput.vue?vue&type=template&id=6d79c564&scoped=true&"
import script from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
export * from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
import style0 from "./ThaiAddressInput.vue?vue&type=style&index=0&id=6d79c564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d79c564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
